module.exports = __webpack_public_path__ + "12fdf617144d0625e50a0ef3bf5a0251.png";